export default "__VITE_ASSET__7bd8f5c9__"